import * as React from "react";
import type { SVGProps } from "react";
const SvgFaceSad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#face-sad_svg__a)">
      <path d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8" />
      <path d="M10 11c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1M14 11c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1s1 .45 1 1v1c0 .55-.45 1-1 1M14.5 15.5c-.13 0-.27-.03-.4-.08 0 0-.99-.42-2.1-.42s-2.09.41-2.1.42c-.5.21-1.09-.02-1.31-.52a.99.99 0 0 1 .52-1.31c.05-.02 1.36-.58 2.9-.58s2.84.56 2.9.58c.51.22.74.81.52 1.32-.16.38-.53.6-.92.6z" />
    </g>
    <defs>
      <clipPath id="face-sad_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFaceSad;
